import { IDataRole } from '../types/IDataRole';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUser } from '../types/IUser';
import { INamedItem, ITypedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetDataRolesParams extends IGetItemsParams {
}

export interface IGetDataRolesResult extends IGetItemsResult {
  dataRoles?: IDataRole[];
  users?: IUser[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  favorites?: string[];
}

export class GetDataRolesRequest extends Request<IGetDataRolesParams, IGetDataRolesResult> {
  constructor(params: IGetDataRolesParams) {
    super('getDataRoles', params);
  }
}
